import { CircularProgress } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import usePrimaryColor from "@root/hooks/usePrimaryColor";


export const SecondaryButton = ({
  loading,
  title,
  onClick,
  type,
  additionalAttribute,
  disabled,
  loadingText,
  padding,
}: IButton) => {
  const { defPrimaryColor } = usePrimaryColor();

  const useStyles = makeStyles(() =>
    createStyles({
      button: (props: { padding?: string; defPrimaryColor?: string; }) => ({
        fontFamily: "Wix Madefor Text",
        fontSize: "16px",
        fontWeight: 500,
        lineHeight: "100%",
        color: props.defPrimaryColor,
        maxHeight: "48px",
        borderRadius: "40px",
        backgroundColor: "#ffffff",
        padding: props.padding ?? "14px 0px",
        wordWrap: "break-word",
        display: "flex !important",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        border: `1px solid ${props.defPrimaryColor}`,

        "&:disabled": {
            color: props.defPrimaryColor,
            border: `1px solid ${props.defPrimaryColor}`,
            backgroundColor: "#ffffff",
            opacity: 0.4,
            cursor: "not-allowed",
        },

        "&:hover": {
            color: props.defPrimaryColor,
            border: `1px solid ${props.defPrimaryColor}`,
            backgroundColor: "#ffffff",
            opacity: 0.4,
        },

        "&:active": {
          color: `${props.defPrimaryColor} !important`,
          border: `1px solid ${props.defPrimaryColor} !important`,
          backgroundColor: "#ffffff !important",
          opacity: "0.4 !important",
        },

        "&:focus-visible": {
          color: `${props.defPrimaryColor} !important`,
          border: `1px solid ${props.defPrimaryColor} !important`,
          backgroundColor: "#ffffff !important",
          opacity: "0.4 !important",
          boxShadow:  "none",
        },
      }),

    })
  );

  const classes = useStyles({ padding, defPrimaryColor });

  return (
    <>
      <button
        type={type}
        disabled={loading || disabled}
        className={`${classes.button} btn btn-primary block w-100 m-0`}
        {...additionalAttribute}
        onClick={onClick}
      >
        {loading ? (
          <div className="flex items-center gap-[8px]">
            <CircularProgress sx={{ scale: "0.6", color: "white" }} />
            {loadingText && <span>{loadingText}</span>}
          </div>
        ) : (
          <>
            {title}
          </>
        )}
      </button>
    </>
  );
};

interface IButton {
  loading?: boolean;
  title: string;
  onClick?: () => void;
  type?: string;
  additionalAttribute?: any;
  disabled?: boolean;
  loadingText?: string;
  padding?: string;
}
